import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './LoginDetailsSkeleton.scss';
import '../../Login/PhoneNo/PhoneNo.scss';
import '../../Login/Login.scss';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { getCreditsAvailable } from '../../../redux/reducers/dashboard.reducer';
import { getCurrentBranding } from '../../../redux/reducers/branding.reducer';
import { Backdrop } from '@material-ui/core';

const LoginDetailsSkeleton = (props) => {
  const {
    isLoading,
    image,
    heading,
    englishText,
    hindiText,
    footerHeading,
    footerSubHeading,
    currentBranding,
    goToMain = () => {},
    value,
    setValue,
    isValid,
    setClick,
    isVerify,
    placeholder,
    password,
    forgotPlaceholder,
    showPoweredBy,
    creditsAvailable,
    history,
  } = props;

  const [showPassword, setPasswordShown] = useState(true);
  console.log(placeholder, password);

  const togglePasswordVisibility = () => {
    setPasswordShown((prevState) => !prevState);
  };

  useEffect(() => {
    if (placeholder === 'Mobile number') {
      const phoneInput = document.querySelector('.react-tel-input .form-control');
      if (phoneInput) {
        phoneInput.focus();
      }
      console.log(placeholder, password);
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        setClick();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setClick, placeholder]);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setClick();
    }
  };

  const focusOnInput = (input) => input && input.focus();

  function removeDialCode(phone, dialCode) {
    // Step 1: keep only digits
    // let digits = phone.replace(/\D/g, '');

    // Step 2: remove dial code from start if present
    if (phone.startsWith(dialCode)) {
      phone = phone.slice(dialCode.length);
    }

    return phone;
  }

  return (
    <>
      <div className='loginComponentsContainer'>
        <Backdrop open style={{ zIndex: '0' }} className='d-block d-md-none' />
        <div className='text-center mt-5 mb-0 mb-md-4 mt-md-0 pt-4 pt-md-0 mx-2 justify-content-center w-50'>
          <img src={currentBranding.branding.client_logo} alt='logo' className='loginLogo' />
          <h1 className='loginClientName'>{currentBranding.branding.client_name}</h1>
          <p className='loginClientTagline my-2'>{currentBranding.branding.client_tagline}</p>
        </div>

        <div className='LoginFooter  pt-5 pb-0 pb-md-5'>
          <div className='position-relative'>
            <h3 className='welcome-title px-4 px-md-0 mb-0'>{heading}</h3>
            <p className='text-muted font welcome-text px-4 px-md-0 mb-0'>{englishText}</p>
            <div className='LoginDetailsSkeleton mx-1 mt-5'>
              {placeholder === 'Mobile number' ? (
                <div
                  className='text-center mt-5 LoginDetailsSkeleton__phoneNoOnly 
            LoginDetailsSkeleton__phoneNoInput hum_yha_hai_dekho'
                >
                  <PhoneInput
                    country={'in'}
                    value={typeof value === 'string' ? value : value?.value || ''}
                    onChange={(phone, country, e, formattedValue) => {
                      // react-phone-input-2 passes phone as string, not event object
                      // Pass the phone number as a string
                      const formatted = removeDialCode(phone, country.dialCode);

                      setValue({ dialCode: country.dialCode, phone: formatted });
                    }}
                    enableSearch={true}
                    countryCodeEditable={false}
                    searchPlaceholder='Search countries'
                    containerClass='phone-input-container'
                    inputClass='phone-input-field'
                    buttonClass='phone-input-button'
                    dropdownClass='phone-input-dropdown'
                    searchClass='phone-input-search'
                    disableSearchIcon={false}
                    enableAreaCodes={false}
                    prefix=''
                    // disableCountryCode
                    inputProps={{
                      name: 'phone',
                      required: true,
                      autoFocus: true,
                      // onKeyPress: handleKeyPress,
                    }}
                    inputStyle={{
                      height: '46px',
                      width: '100%',
                      fontSize: '16px',
                    }}
                    buttonStyle={{
                      height: '46px',
                      background: 'white'
                    }}
                    searchStyle={{
                      width: '100%',
                      padding: '10px',
                    }}
                  />
                </div>
              ) : (
                <div
                  className='LoginDetailsSkeleton__phoneNoOnly LoginDetailsSkeleton__phoneNoInput'
                  style={{ marginTop: '1rem' }}
                >
                  <label className='has-float-label my-auto input_ke_label_hain_hum'>
                    <input
                      className='form-control formInput '
                      name='Mobile Number'
                      type={
                        password
                          ? showPassword
                            ? 'password'
                            : 'text'
                          : placeholder === 'Mobile number'
                          ? 'number'
                          : 'text'
                      }
                      placeholder={placeholder}
                      onChange={(event) => {
                        setValue(event.target.value);
                        console.log(password, showPassword, placeholder);
                      }}
                      value={value}
                      ref={focusOnInput}
                      // onKeyPress={handleKeyPress}
                    />
                    <span>{placeholder}</span>
                    {password &&
                      (showPassword ? (
                        <i
                          style={{ marginTop: '6px' }}
                          className='PhoneNo__show'
                          onClick={togglePasswordVisibility}
                          onKeyDown={togglePasswordVisibility}
                          role='button'
                          tabIndex={0}
                        >
                          <VisibilityOff />
                        </i>
                      ) : (
                        <i
                          style={{ marginTop: '6px' }}
                          className='PhoneNo__show'
                          onClick={togglePasswordVisibility}
                          onKeyDown={togglePasswordVisibility}
                          role='button'
                          tabIndex={0}
                        >
                          <Visibility />
                        </i>
                      ))}
                  </label>
                </div>
              )}
            </div>
            <div className='d-flex justify-content-center LoginDetailsSkeleton__phoneNoInput'>
              {isLoading ? (
                <Button variant='customPrimary' className='mt-4 mb-b mx-4 mx-lg-0 py-2 '>
                  Verifying..
                </Button>
              ) : (
                <Button
                  variant='customPrimary'
                  className='mt-4  mx-4 mx-lg-0 py-2'
                  onClick={() => setClick()}
                >
                  {isVerify ? 'Verifying..' : 'Proceed'}
                </Button>
              )}
            </div>
            {isValid && (
              <small className='text-danger d-block text-center errorTxt'>
                Please enter a valid {placeholder}
              </small>
            )}
            {placeholder === 'Password' &&
              heading === 'Enter Password' &&
              creditsAvailable >= 1 && (
                <Row className='mx-auto justify-content-center' style={{ width: '90%' }}>
                  <span
                    className='PhoneNo__forgot p-1 text-center my-4 errorTxt'
                    onClick={() => forgotPlaceholder()}
                    onKeyDown={() => forgotPlaceholder()}
                    role='button'
                    tabIndex='-1'
                    style={{
                      fontFamily: 'Montserrat-Medium',
                      fontSize: '14px',
                      color: 'var(--primary-blue)',
                    }}
                  >
                    Forgot {placeholder}?
                  </span>
                </Row>
              )}
            <div className='my-2 w-100 px-4 d-md-none  d-flex gap-2 justify-content-between align-items-center'>
              <hr className='w-100' />
              <p className='text -muted text10 mb-0'>OR</p>
              <hr className='w-100' />
            </div>
            <div className='d-md-none d-flex justify-content-center LoginDetailsSkeleton__phoneNoInput'>
              <Button
                variant='customSecondary'
                style={{ border: 'transparent', background: 'transparent' }}
                className='mb-3'
                onClick={goToMain}
              >
                Explore as a guest
              </Button>
            </div>
          </div>
          {heading === 'Welcome!' && (
            <div className='LoginDetailsSkeleton__terms-button d-none d-md-block'>
              <p className='mb-0'>
                By continuing, you agree to the{' '}
                <span
                  role='button'
                  className='LoginDetailsSkeleton__terms-btn'
                  onClick={() => history.push('/termsandconditions')}
                >
                  Terms & conditions
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  creditsAvailable: getCreditsAvailable(state),
  currentBranding: getCurrentBranding(state),
});

export default connect(mapStateToProps, null)(LoginDetailsSkeleton);
